import { IDisciplin, IProjectDeprecated } from "@mctypes/global.types";
import { Card, Checkbox, Group, Stack, Text } from "@mantine/core";
import { ColDef } from "ag-grid-community";
import React from "react";
import FoldableSection from "../../../components/FoldableSection/FoldableSection";
import ViewEditTable from "../../../components/ViewEditTable/ViewEditTable";
import { VETEmptyValidator } from "../../../components/ViewEditTable/ViewEditTableValidators";
import { setShowSuccessMessageThunk } from "../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { ToastMessagesEnums } from "../../../mc-shared/sharedConstants";
import { setDisciplinesInRedux, setUseDefaultDisciplinesInRedux } from "../../actions";
import { DISCIPLINER } from "../start/constants";
import { doUpdateDefaultDisciplines, doUpdateDisciplines } from "./restQueries";

const ProjectDisciplineSettingsPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const project = useAppSelector((state) => state.adminReducer.project as IProjectDeprecated);

  const toggleDefaultDisciplines = async (bool: boolean) => {
    await doUpdateDefaultDisciplines(project._id, bool);
    dispatch(setUseDefaultDisciplinesInRedux(bool));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
  };

  const updateDisciplines = async (data: IDisciplin[]) => {
    const _disciplines = await doUpdateDisciplines(project._id, data);
    dispatch(setDisciplinesInRedux(_disciplines));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
  };

  const columns: ColDef<IDisciplin>[] = [
    {
      field: "short",
      headerName: "Forkortelse",
      editable: true,
    },
    {
      field: "long",
      headerName: "Disiplin",
      editable: true,
      flex: 1,
    },
  ];

  const newItemTemplateObject = {
    short: "",
    long: "",
  };

  return (
    <Card withBorder p="md">
      <Stack gap="sm" w="100%">
        <Group justify="left" align="center" gap="xs" wrap="nowrap">
          <Checkbox
            onChange={(e) => toggleDefaultDisciplines(e.currentTarget.checked)}
            checked={project.useDefaultDisciplines}
          />
          <Text size="sm" fw={600}>
            Bruk standarddisipliner
          </Text>
        </Group>

        {project.useDefaultDisciplines === true && (
          <FoldableSection folded>
            <FoldableSection.Header>
              <Text size="md" fw={500}>
                Standarddisipliner
              </Text>
            </FoldableSection.Header>
            <FoldableSection.Body>
              <ViewEditTable
                validators={[VETEmptyValidator, VETEmptyValidator]}
                data={DISCIPLINER}
                columns={columns}
                onSave={updateDisciplines}
                newItemTemplateObject={newItemTemplateObject}
              />
            </FoldableSection.Body>
          </FoldableSection>
        )}

        <FoldableSection>
          <FoldableSection.Header>
            <Text size="md" fw={500}>
              Disipliner for prosjekt
            </Text>
          </FoldableSection.Header>
          <FoldableSection.Body>
            <ViewEditTable
              validators={[VETEmptyValidator, VETEmptyValidator]}
              data={project.disciplines}
              columns={columns}
              onSave={updateDisciplines}
              newItemTemplateObject={newItemTemplateObject}
              canEdit={true}
            />
          </FoldableSection.Body>
        </FoldableSection>
      </Stack>
    </Card>
  );
};

export default ProjectDisciplineSettingsPage;
